import { BandcampIcon, SpotifyIcon } from "@/components/icons";
import theme from "@/styles/theme";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from '@mui/icons-material/Instagram';
import {Container, Grid, Link} from "@mui/material";
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import LinkStyled from "../LinkStyled";

export const NetworkLinks = ({content}) => {
  return (
    <>
      <Container maxWidth="xl">
        <Grid
          container
          justifyContent="center"
          sx={{
            backgroundColor: `${
              content.background_color === "lightgrey"
                ? grey[100]
                : content.background_color === "white"
                ? theme.palette.common.white
                : ""
            } !important`,
            py: 1,
            [theme.breakpoints.up("md")]: {
              py: 3,
            },
          }}
        >
          <Grid item xs={10}>
            <Typography
              variant="body1"
              color="secondary.main"
              sx={{
                textTransform: "uppercase",
                fontSize: "1.125rem",
                textAlign: "center",
              }}
            >
              <LinkStyled
                href={`https://${content.website}`}
                label={content.website}
              />
            </Typography>
            <Stack direction="row" justifyContent="center" spacing={0}>
              {content.Social_Link.map((link) => {
                return (
                <Link key={link.id} href={link.Target} target="_blank" rel="noopener noreferrer">
                  <IconButton color="secondary">
                    {link.Type == "facebook" && (
                      <FacebookRoundedIcon sx={{fontSize: 32}} />
                    )}
                    {link.Type == "instagram" && (
                      <InstagramIcon sx={{fontSize: 32}} />
                    )}
                    {link.Type == "twitter" && (
                      <TwitterIcon sx={{fontSize: 32}} />
                    )}
                    {link.Type == "youtube" && (
                      <YouTubeIcon sx={{fontSize: 32}} />
                    )}
                    {link.Type == "spotify" && (
                      <SvgIcon
                        color="secondary"
                        sx={{
                          fontSize: 32,
                          color: theme.palette.secondary.main,
                        }}
                      >
                        <SpotifyIcon />
                      </SvgIcon>
                    )}
                    {link.Type == "bandcamp" && (
                      <SvgIcon
                        color="secondary"
                        sx={{
                          fontSize: 32,
                          color: theme.palette.secondary.main,
                        }}
                      >
                        <BandcampIcon />
                      </SvgIcon>
                    )}
                  </IconButton>
                </Link>
                );
              })}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
